/**
 * placement = top, left, both
 */
const menus = {
  dashboard: {
    label: "Dashboard",
    link: "/dashboard",
    icon: "",
    isExternal: false,
    placement: "both",
    key: "T_1_S_1",
    children: [],
  },
  catgory: {
    label: "Category",
    link: "/category",
    icon: "",
    isExternal: false,
    placement: "both",
    key: "T_2_S_2",
    children: [],
  },
  food: {
    label: "Food",
    link: "/food",
    icon: "",
    isExternal: false,
    placement: "both",
    key: "T_3_S_3",
    children: [],
  },
  orders: {
    label: "Orders",
    link: "/order",
    icon: "",
    isExternal: false,
    placement: "both",
    key: "T_4_S_4",
    children: [],
  },
  staff: {
    label: "Staff",
    link: "/staff",
    icon: "",
    isExternal: false,
    placement: "both",
    key: "T_5_S_5",
    children: [],
  },
  reports: {
    label: "Reports",
    link: "",
    icon: "",
    isExternal: false,
    placement: "top",
    key: "T_6_S_6",
    children: [
      {
        label: "Sales",
        link: "/reports/sales",
        icon: "",
        isExternal: false,
        key: "T_6_S_6_L_1",
      },
      {
        label: "Item Wise Sales",
        link: "/reports/item-wise-sales",
        icon: "",
        isExternal: false,
        key: "T_6_S_6_L_2",
      },
      {
        label: "Refunds",
        link: "/reports/refunds",
        icon: "",
        isExternal: false,
        key: "T_6_S_6_L_3",
      },
      {
        label: "Customers",
        link: "/reports/customers",
        icon: "",
        isExternal: false,
        key: "T_6_S_6_L_4",
      },
      {
        label: "Orders",
        link: "/reports/orders",
        icon: "",
        isExternal: false,
        key: "T_6_S_6_L_5",
      },
      {
        label: "Coupons",
        link: "/reports/coupons",
        icon: "",
        isExternal: false,
        key: "T_6_S_6_L_6",
      },
    ],
  },
  inventory: {
    label: "Inventory",
    link: "",
    icon: "",
    isExternal: false,
    placement: "top",
    key: "T_7_S_7",
    children: [
      {
        label: "Ingredients",
        link: "/inventory/ingredients",
        icon: "",
        isExternal: false,
        key: "T_7_S_7_L_1",
      },
      {
        label: "Purchase Report",
        link: "/inventory/purchase-item/reports",
        icon: "",
        isExternal: false,
        key: "T_7_S_7_L_2",
      },
      {
        label: "Supplier",
        link: "/inventory/supplier",
        icon: "",
        isExternal: false,
        key: "T_7_S_7_L_3",
      },
      {
        label: "Stock",
        link: "/inventory/report",
        icon: "",
        isExternal: false,
        key: "T_7_S_7_L_4",
      },
      {
        label: "Recipe",
        link: "/inventory/recipe",
        icon: "",
        isExternal: false,
        key: "T_7_S_7_L_5",
      },
      {
        label: "Wastage",
        link: "/inventory/wastage",
        icon: "",
        isExternal: false,
        key: "T_7_S_7_L_7",
      },
      {
        label: "Final Report",
        link: "/inventory/final-report",
        icon: "",
        isExternal: false,
        key: "T_7_S_7_L_6",
      },
    ],
  },
  tables: {
    label: "Tables",
    link: "/table",
    icon: "",
    isExternal: false,
    placement: "both",
    key: "T_8_S_8",
    children: [],
  },
  restaurants: {
    label: "Restaurants",
    link: "/restaurants",
    icon: "",
    isExternal: false,
    placement: "both",
    key: "T_51_S_51",
    children: [],
  },
  users: {
    label: "Users",
    link: "/users",
    icon: "",
    isExternal: false,
    placement: "both",
    key: "T_52_S_52",
    children: [],
  },
  groups: {
    label: "Groups",
    link: "/groups",
    icon: "",
    isExternal: false,
    placement: "both",
    key: "T_53_S_53",
    children: [],
  },
  sales: {
    label: "Sales",
    link: "",
    icon: "",
    isExternal: false,
    placement: "top",
    key: "T_54_S_54",
    children: [
      {
        label: "Orders",
        link: "/sales/orders",
        icon: "",
        isExternal: false,
        key: "T_54_S_54_L_1",
      },
      {
        label: "Disburse",
        link: "/sales/disbursement",
        icon: "",
        isExternal: false,
        key: "T_54_S_54_L_2",
      },
      {
        label: "Disbursement History",
        link: "/sales/disbursement-history",
        icon: "",
        isExternal: false,
        key: "T_54_S_54_L_3",
      },
    ],
  },
};

export const ADMIN_MENUS = [
  menus.dashboard,
  menus.catgory,
  menus.food,
  menus.orders,
  menus.tables,
  menus.staff,
  menus.reports,
  menus.inventory,
];

export const GENERAL_MENUS = [menus.dashboard, menus.food, menus.orders, menus.tables];

export const SUPER_MENUS = [menus.restaurants, menus.users, menus.groups];
